import React from "react";

const PRINT_ITEMS_PER_SECTION = 7;
const PRINT_SECTIONS_PER_PAGE = 4;

const splitItemsForPrint = (items) => {
  const sections = [];

  for (let index = 0; index < items.length; index += PRINT_ITEMS_PER_SECTION) {
    sections.push(items.slice(index, index + PRINT_ITEMS_PER_SECTION));
  }

  return sections.length > 0 ? sections : [[]];
};

const groupSectionsIntoPages = (sections) => {
  const pages = [];

  for (
    let index = 0;
    index < sections.length;
    index += PRINT_SECTIONS_PER_PAGE
  ) {
    pages.push(sections.slice(index, index + PRINT_SECTIONS_PER_PAGE));
  }

  return pages;
};

const ReceiptCard = ({
  receipt,
  formatCurrency,
  className = "",
  showHeader = true,
  showTotal = true,
  sectionNumber,
  totalSections,
}) => (
  <div className={`receipt-card ${className}`.trim()}>
    {showHeader ? (
      <div className="receipt-header">
        <img
          className="receipt-logo"
          src="/images/zawkhinLogo.PNG"
          alt="Zaw Khin Grocery & Import Shop"
        />
        <h2>ZAW KHIN MARKET</h2>
        <p className="receipt-subtitle">Sales Receipt</p>
        <p className="receipt-phone">081-2121995</p>
        <p className="receipt-transaction-id">#{receipt.transactionId}</p>
        <p className="receipt-date">
          {new Date().toLocaleDateString()} {new Date().toLocaleTimeString()}
        </p>
      </div>
    ) : (
      <div className="receipt-continuation-header">
        <strong>Receipt continued</strong>
        <span>#{receipt.transactionId}</span>
        <span>
          Section {sectionNumber} of {totalSections}
        </span>
      </div>
    )}
    <div className="receipt-body">
      <table>
        <thead>
          <tr>
            <th>Item</th>
            <th className="receipt-number-cell">Qty</th>
            <th className="receipt-number-cell">Total</th>
          </tr>
        </thead>
        <tbody>
          {receipt.items.map((item, index) => (
            <tr key={`${item.barcode || item.name}-${index}`}>
              <td>
                <div>{item.name}</div>
                <div className="text-muted receipt-item-meta">
                  MMK {formatCurrency(item.unitPrice)} / {item.unitName || "unit"}
                  {(item.conversionFactor || 1) > 1 && ` · ${item.conversionFactor} base units`}
                </div>
              </td>
              <td className="receipt-number-cell">{item.quantity}</td>
              <td className="receipt-number-cell receipt-line-total">
                MMK {formatCurrency(item.totalPrice)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {showTotal && (
        <div className="receipt-final-summary">
          <div className="receipt-total">MMK {formatCurrency(receipt.totalAmount)}</div>
          <p className="receipt-thank-you">Thank you for shopping with us.</p>
        </div>
      )}
    </div>
  </div>
);

function ReceiptPrintLayout({ receipt, formatCurrency }) {
  const printSections = splitItemsForPrint(receipt.items);
  const printPages = groupSectionsIntoPages(printSections);

  return (
    <>
      <ReceiptCard
        receipt={receipt}
        formatCurrency={formatCurrency}
        className="receipt-screen-copy"
      />
      <div className="receipt-print-sheet" aria-hidden="true">
        {printPages.map((pageSections, pageIndex) => (
          <div
            className="receipt-print-page"
            key={`receipt-print-page-${pageIndex + 1}`}
          >
            {pageSections.map((items, pageSectionIndex) => {
              const currentSectionIndex =
                pageIndex * PRINT_SECTIONS_PER_PAGE + pageSectionIndex;
              const sectionNumber = currentSectionIndex + 1;
              const isFinalSection = sectionNumber === printSections.length;

              return (
                <div
                  className="receipt-print-slot"
                  key={`receipt-print-section-${sectionNumber}`}
                >
                  <ReceiptCard
                    receipt={{ ...receipt, items }}
                    formatCurrency={formatCurrency}
                    className="receipt-print-copy"
                    showHeader={currentSectionIndex === 0}
                    showTotal={isFinalSection}
                    sectionNumber={sectionNumber}
                    totalSections={printSections.length}
                  />
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </>
  );
}

export default ReceiptPrintLayout;
